(function () {

  'use strict';


  const drawer = document.querySelector('#vitalcare-cart-drawer');

  if (!drawer) return;
  if (drawer.parentElement !== document.body) {
    document.body.appendChild(drawer);
  }


  let ferticareVariantId = 49896912388453;

const savingsMap = {

  "One Bottle - (30 capsules)": 31100,

  "Two Bottles - (60 capsules)": 70100,

  "Three Bottles - (90 capsules)": 75100

};

const openDrawer = () => {

  drawer.classList.add('is-open');

};


const closeDrawer = () => {

  drawer.classList.remove('is-open');

};


  const formatMoney = (cents) => {

    return new Intl.NumberFormat('en-PH', {

      style: 'currency',

      currency: 'PHP'

    }).format(cents / 100);

  };





  const updateQuantity = async (key, quantity) => {

    try {

      await fetch('/cart/change.js', {

        method: 'POST',

        headers: {

          'Content-Type': 'application/json'

        },

        body: JSON.stringify({

          id: key,

          quantity: quantity

        })

      });


      await loadCart();


    } catch (error) {

      console.error('VITALCARE QUANTITY ERROR:', error);

    }

  };

  const removeItem = async (key) => {

  try {

    await fetch('/cart/change.js', {

      method: 'POST',

      headers: {

        'Content-Type': 'application/json'

      },

      body: JSON.stringify({

        id: key,

        quantity: 0

      })

    });


    await loadCart();


  } catch(error) {

    console.error('REMOVE ITEM ERROR:', error);

  }

};




  const addFerticare = async () => {

    const button = drawer.querySelector('[data-vc-add-ferticare]');


    try {


      if (button) {

        button.textContent = 'Adding...';

        button.disabled = true;

      }



      await fetch('/cart/add.js', {

        method: 'POST',

        headers: {

          'Content-Type': 'application/json'

        },

        body: JSON.stringify({

          id: Number(ferticareVariantId),

          quantity: 1

        })

      });



      await loadCart();



     if (button) {

  button.textContent = 'Added ✓';

  button.disabled = true;


  setTimeout(() => {

    button.textContent = '+ Add Ferticare';

    button.disabled = false;

  }, 2000);

}



    } catch(error) {


      console.error('FERTICARE ADD ERROR:', error);


      if (button) {

        button.textContent = '+ Add Ferticare';

        button.disabled = false;

      }


    }

  };








  const setupFerticareSelector = () => {


    const select = drawer.querySelector('[data-vc-ferticare-select]');

    const price = drawer.querySelector('[data-vc-ferticare-price]');


    if (!select) return;



    ferticareVariantId = select.value;



    select.addEventListener('change', () => {


      ferticareVariantId = select.value;



      const selectedPrice = select
        .selectedOptions[0]
        .dataset
        .price;



      if (price) {


        price.textContent = formatMoney(
          Number(selectedPrice)
        );


      }


    });



    const addButton = drawer.querySelector('[data-vc-add-ferticare]');


    if (addButton) {


      addButton.addEventListener('click', addFerticare);


    }


  };





  setupFerticareSelector();


  const loadCart = async () => {


    try {


      const response = await fetch('/cart.js');


      const cart = await response.json();



      const itemsContainer = drawer.querySelector('.vc-cart-items');

      const total = drawer.querySelector('[data-vc-cart-total]');
      const upsell = drawer.querySelector('.vc-cart-upsell');



      if (!cart.items.length) {


        itemsContainer.innerHTML = `

          <p>Your cart is empty.</p>

        `;


        total.textContent = '₱0.00';


        return;


      }







      itemsContainer.innerHTML = cart.items.map(item => `



        <div class="vc-cart-item">


          <img

            src="${item.image}"

            alt="${item.product_title}"

          >



          <div class="vc-cart-item-info">



<div class="vc-cart-title-row">

  <div class="vc-cart-name">

    <strong>

      ${item.product_title}

    </strong>


    <div class="vc-cart-variant">

      ${item.variant_title || ''}

    </div>

  </div>


 <p class="vc-cart-price">

  <strong>
    ${formatMoney(item.final_line_price)}
  </strong>

  ${savingsMap[item.variant_title] ? `

    <s>
      ${formatMoney(
        item.final_line_price +
        (savingsMap[item.variant_title] * item.quantity)
      )}
    </s>

  ` : ''}

</p>

</div>


${savingsMap[item.variant_title] ? `

  <div class="vc-cart-saving">
    ✓ You saved ${formatMoney(
      savingsMap[item.variant_title] * item.quantity
    )}
  </div>

` : ''}




<div class="vc-cart-actions">


  <div class="vc-cart-qty">


    <button

      class="vc-minus"

      data-key="${item.key}"

      data-qty="${item.quantity}"

    >

      -

    </button>



    <span>

      ${item.quantity}

    </span>




    <button

      class="vc-plus"

      data-key="${item.key}"

      data-qty="${item.quantity}"

    >

      +

    </button>


  </div>



  <button

    class="vc-remove"

    data-key="${item.key}"

  >

    Remove

  </button>


</div>





           



          </div>


        </div>



      `).join('');






      total.textContent = formatMoney(cart.total_price);
const hasFerticare = cart.items.some(item =>
  item.product_title.toLowerCase().includes('ferticare')
);


if (upsell) {

  upsell.style.display = hasFerticare ? 'none' : 'block';

}






      drawer.querySelectorAll('.vc-plus')

        .forEach(button => {


          button.addEventListener('click', () => {


            const key = button.dataset.key;

            const qty = Number(button.dataset.qty);


            updateQuantity(key, qty + 1);


          });


        });







      drawer.querySelectorAll('.vc-minus')

        .forEach(button => {


          button.addEventListener('click', () => {


            const key = button.dataset.key;

            const qty = Number(button.dataset.qty);



            if (qty > 0) {


              updateQuantity(key, qty - 1);


            }


          });


        });



drawer.querySelectorAll('.vc-remove')

.forEach(button => {


  button.addEventListener('click', () => {


    const key = button.dataset.key;


    removeItem(key);


  });


});


      


    } catch(error) {


      console.error('VITALCARE CART ERROR:', error);


    }


  };









  window.addEventListener('vitalcare:open-cart', () => {


    openDrawer();


    loadCart();


  });








  drawer.querySelectorAll('[data-vc-cart-close]')

    .forEach(button => {


      button.addEventListener('click', closeDrawer);


    });







  window.openVitalcareDrawer = openDrawer;



})();